import { render } from "./BookingFormFlight.vue?vue&type=template&id=b8d0f7c2"
import script from "./BookingFormFlight.vue?vue&type=script&lang=js"
export * from "./BookingFormFlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__